import { FeedbackRoundStatus } from '@brafton/feedback-api';

/** Count of projects (feedback rounds) in each status, keyed by the API enum. */
export type ProjectStatusCounts = Record<FeedbackRoundStatus, number>;

/** A single status summary tile shown in the overview banner. */
export interface ProjectStatusTile {
  status: FeedbackRoundStatus;
  label: string;
}

/**
 * The status tiles rendered in the overview banner, in display order. The
 * accent color for each is driven by the `--fb-status-*` CSS variables via a
 * `tile--<status>` class, so colors stay defined alongside the design tokens.
 */
export const PROJECT_STATUS_TILES: readonly ProjectStatusTile[] = [
  { status: FeedbackRoundStatus.Open, label: 'Open' },
  { status: FeedbackRoundStatus.Completed, label: 'Completed' },
  { status: FeedbackRoundStatus.Closed, label: 'Closed' },
  { status: FeedbackRoundStatus.Cancelled, label: 'Cancelled' },
];